import React, { Component } from 'react'
import { translate } from 'react-i18next'

import PropTypes from 'prop-types'
import getByPath from 'lodash/get'
import clone from 'lodash/cloneDeep'

import Modal from 'react-bootstrap-modal'

class CopyModal extends Component {
  static propTypes = {
    allCustomizedPlans: PropTypes.arrayOf(PropTypes.object),
    sourceTrip: PropTypes.object,
    user: PropTypes.object,
    isCopyModalOpen: PropTypes.bool,
    onSave: PropTypes.func,
    onClose: PropTypes.func,
    t: PropTypes.func
  }

  static defaultProps = {
    allCustomizedPlans: [],
    sourceTrip: {}
  }

  constructor(props) {
    super(props)

    this.state = {
      title: '',
      selectedDestinationId: ''
    }
  }

  componentWillReceiveProps(next) {
    const title = getByPath(next, 'sourceTrip.tripDetails.title', '')

    this.setState(() => ({
      title: `Copy of ${title}`
    }))
  }

  render() {
    const prepaidOption =
      this.props.user.plannerProfile && this.props.user.plannerProfile.allowPrepaidTrips ? (
        <option value="prepaid">New Prepaid Order</option>
      ) : (
        ''
      )
    return (
      <Modal
        show={this.props.isCopyModalOpen}
        onHide={() => {
          this.props.onClose()
        }}
        className="copy-modal"
        aria-labelledby="ModalHeader"
      >
        <Modal.Header closeButton={true} />
        <Modal.Body>
          <div className="form-group clearfix">
            <label className="col-md-3 copy-modal__label" htmlFor="title">
              {this.props.t('title')}
            </label>
            <div className="col-md-9">
              <input
                type="text"
                id="title"
                value={this.state.title}
                onChange={e => {
                  e.persist()

                  this.setState(() => ({
                    title: e.target.value
                  }))
                }}
                className="form-control copy-modal__input"
              />
            </div>
          </div>
          <div className="form-group clearfix mb-0">
            <label className="col-md-3 copy-modal__label" htmlFor="title">
              {this.props.t('order')}
            </label>
            <div className="col-md-9">
              <select
                name="order"
                id="order"
                value={this.state.selectedDestinationId}
                onChange={e => {
                  e.persist()

                  this.setState(() => ({
                    selectedDestinationId: e.target.value
                  }))
                }}
                className="form-control copy-modal__input mb-0"
              >
                <option value="" hidden disabled>
                  Select order
                </option>
                {prepaidOption}
                {this.props.allCustomizedPlans.filter(plan => plan.id !== this.props.sourceTrip.id).map((plan, i) => {
                  return (
                    <option key={i} value={plan.id}>
                      {plan.tripDetails.title}
                    </option>
                  )
                })}
              </select>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="copy-modal__save-button"
            onClick={e => {
              e.stopPropagation()

              this.props.onSave(clone(this.state))
            }}
          >
            {this.props.t('save')}
          </button>
        </Modal.Footer>
      </Modal>
    )
  }
}

export default translate('copy_trip_modal')(CopyModal)



// WEBPACK FOOTER //
// src/components/MyTrips/CopyModal.js